import CinePlayer from './CinePlayer';
import type { CinePlayerProps } from './CinePlayer';

export { CinePlayer, CinePlayerProps };
export default CinePlayer;